import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IUiState } from './state'
import { AlsUser } from '@/models/als/AlsUser'

const mutations: MutationTree<IUiState> = {    
    [types.UI_SET_CONTENT_HEIGHT]: (state,height:number) => {
        state.contentHeight = height
    },
    [types.UI_SET_RIGHT_DRAWER_OPEN]: (state,open:boolean) => {
        state.rightDrawerOpen = open
    },
    [types.UI_SET_RIGHT_DRAWER_ENABLE]: (state,enable:boolean) => {
        state.rightDrawerEnable = enable
    },
    [types.UI_SET_DRAWER_OPEN]: (state,open:boolean) => {
        state.drawerOpen = open
    },
    [types.UI_SET_DRAWER_ENABLE]: (state,enable:boolean) => {
        state.drawerEnable = enable
    },
    [types.UI_CLOSE_SNACKBAR]: (state) => {
        state.snackMessages = []
    },
    [types.UI_ADD_SNACK_MESSAGE]: (state,message:string) => {
        state.snackMessages.splice(0,0,message)
    },         
    [types.UI_SET_CART_VISIBLITY]: (state,visibility:boolean) => {
        state.showCart = visibility
    },    


    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_USER]: (state,search:string) => {
        state.searchUser = search
    },    
    [types.UI_SET_SORT_USER_DESC]: (state,desc:boolean) => {
        state.sortUserDesc = desc
    },
    [types.UI_SET_SORT_USER_BY]: (state,sort:string) => {
        state.sortUserBy = sort
    },

     //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_MAIL_TEMPLATE]: (state,search:string) => {
        state.searchMailTemplate = search
    },    
    [types.UI_SET_SORT_MAIL_TEMPLATE_DESC]: (state,desc:boolean) => {
        state.sortMailTemplateDesc = desc
    },
    [types.UI_SET_SORT_MAIL_TEMPLATE_BY]: (state,sort:string) => {
        state.sortMailTemplateBy = sort
    },

     //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_MAIL_SKIN]: (state,search:string) => {
        state.searchMailSkin = search
    },    
    [types.UI_SET_SORT_MAIL_SKIN_DESC]: (state,desc:boolean) => {
        state.sortMailSkinDesc = desc
    },
    [types.UI_SET_SORT_MAIL_SKIN_BY]: (state,sort:string) => {
        state.sortMailSkinBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // PISCINE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_PISCINE]: (state,search:string) => {
        state.searchPiscine = search
    },    
    [types.UI_SET_SORT_PISCINE_DESC]: (state,desc:boolean) => {
        state.sortPiscineDesc = desc
    },
    [types.UI_SET_SORT_PISCINE_BY]: (state,sort:string) => {
        state.sortPiscineBy = sort
    },
    [types.UI_SET_MONTH_PISCINE]: (state,month:string) => {
        state.monthPiscine = month
    },  

    //////////////////////////////////////////////////////////////////
    // ACTIVITY
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_ACTIVITY]: (state,search:string) => {
        state.searchActivity = search
    },    
    [types.UI_SET_SORT_ACTIVITY_DESC]: (state,desc:boolean) => {
        state.sortActivityDesc = desc
    },
    [types.UI_SET_SORT_ACTIVITY_BY]: (state,sort:string) => {
        state.sortActivityBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // FORFAIT
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_FORFAIT]: (state,search:string) => {
        state.searchForfait = search
    },    
    [types.UI_SET_SORT_FORFAIT_DESC]: (state,desc:boolean) => {
        state.sortForfaitDesc = desc
    },
    [types.UI_SET_SORT_FORFAIT_BY]: (state,sort:string) => {
        state.sortForfaitBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // MNS
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_MNS]: (state,search:string) => {
        state.searchMns = search
    },    
    [types.UI_SET_SORT_MNS_DESC]: (state,desc:boolean) => {
        state.sortMnsDesc = desc
    },
    [types.UI_SET_SORT_MNS_BY]: (state,sort:string) => {
        state.sortMnsBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // CONTACT
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_CONTACT]: (state,search:string) => {
        state.searchContact = search
    },    
    [types.UI_SET_SORT_CONTACT_DESC]: (state,desc:boolean) => {
        state.sortContactDesc = desc
    },
    [types.UI_SET_SORT_CONTACT_BY]: (state,sort:string) => {
        state.sortContactBy = sort
    },
    [types.UI_SET_MONTH_CONTACT]: (state,month:string) => {
        state.monthContact = month
    },  

    //////////////////////////////////////////////////////////////////
    // NEWSLETTER
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_NEWSLETTER]: (state,search:string) => {
        state.searchNewsletter = search
    },    
    [types.UI_SET_SORT_NEWSLETTER_DESC]: (state,desc:boolean) => {
        state.sortNewsletterDesc = desc
    },
    [types.UI_SET_SORT_NEWSLETTER_BY]: (state,sort:string) => {
        state.sortNewsletterBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // COURS
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_COURS]: (state,search:string) => {
        state.searchCours = search
    },    
    [types.UI_SET_SORT_COURS_DESC]: (state,desc:boolean) => {
        state.sortCoursDesc = desc
    },
    [types.UI_SET_SORT_COURS_BY]: (state,sort:string) => {
        state.sortCoursBy = sort
    },

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_COMMANDE]: (state,search:string) => {
        state.searchCommande = search
    },    
    [types.UI_SET_SORT_COMMANDE_DESC]: (state,desc:boolean) => {
        state.sortCommandeDesc = desc
    },
    [types.UI_SET_SORT_COMMANDE_BY]: (state,sort:string) => {
        state.sortCommandeBy = sort
    },
    [types.UI_SET_MONTH_COMMANDE]: (state,month:string) => {
        state.monthCommande = month
    },  

    
    //////////////////////////////////////////////////////////////////
    // FAMILY
    /////////////////////////////////////////////////////////////////
    [types.UI_SET_SEARCH_FAMILY]: (state,search:string) => {
        state.searchFamily = search
    },    
    [types.UI_SET_SORT_FAMILY_DESC]: (state,desc:boolean) => {
        state.sortFamilyDesc = desc
    },
    [types.UI_SET_SORT_FAMILY_BY]: (state,sort:string) => {
        state.sortFamilyBy = sort
    },

}

export default mutations